var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auto-dial-container"},[_c('label',[_vm._v("Address")]),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":!_vm.__PROPediting,"test-id":"autoDialAddress"},domProps:{"value":_vm.__PROPvalue},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }